import React from "react";
import { Routes, Route } from "react-router-dom";
import DynamicPage from "../pages/DynamicPage";
import Blog from "../pages/Blog";
import BlogSlug from "../pages/BlogSlug";
import Kunde1DynamicPage from "../customers/kunde1/pages/DynamicPage";
import Kunde2DynamicPage from "../customers/kunde2/pages/DynamicPage";
import DefaultDynamicPage from "../customers/default/pages/DynamicPage";
import AuthConsume from "../pages/AuthConsume";
import Login from "../pages/Login";
import Portal from "../pages/Portal";
import Kunde1Homepage from "../customers/kunde1/Homepage";
import Kunde2Homepage from "../customers/kunde2/Homepage";
import DefaultHomepage from "../customers/default/Homepage";
import { getCustomerKey } from "../utils/domain";
import ProtectedRoute from "../auth/ProtectedRoute";
import { getBlogBaseSlug } from "../utils/blogRoutes";

export default function PageRouter() {
  const key = getCustomerKey();
  const enBlogBase = getBlogBaseSlug("en", key);
  const deBlogBase = getBlogBaseSlug("de", key);
  const enBlogPath = `/en/${enBlogBase}`;
  const deBlogPath = `/${deBlogBase}`;

  const homeByCustomer = {
    kunde1: <Kunde1Homepage />,
    kunde2: <Kunde2Homepage />,
    default: <DefaultHomepage />
  } as const;
  const dynamicByCustomer = {
    kunde1: <Kunde1DynamicPage />,
    kunde2: <Kunde2DynamicPage />,
    default: <DefaultDynamicPage />
  } as const;

  return (
    <Routes>
      <Route path="/auth/consume" element={<AuthConsume />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/portal/*"
        element={
          <ProtectedRoute>
            <Portal />
          </ProtectedRoute>
        }
      />
      <Route path={enBlogPath} element={<Blog />} />
      <Route path={`${enBlogPath}/:slug`} element={<BlogSlug />} />
      {enBlogPath !== "/en/blog" ? <Route path="/en/blog" element={<Blog />} /> : null}
      {enBlogPath !== "/en/blog" ? <Route path="/en/blog/:slug" element={<BlogSlug />} /> : null}
      <Route path="/en" element={homeByCustomer[key]} />
      <Route path="/en/:slug/*" element={dynamicByCustomer[key] ?? <DynamicPage />} />
      <Route path={deBlogPath} element={<Blog />} />
      <Route path={`${deBlogPath}/:slug`} element={<BlogSlug />} />
      {deBlogPath !== "/blog" ? <Route path="/blog" element={<Blog />} /> : null}
      {deBlogPath !== "/blog" ? <Route path="/blog/:slug" element={<BlogSlug />} /> : null}
      <Route path="/" element={homeByCustomer[key]} />
      <Route path=":slug/*" element={dynamicByCustomer[key] ?? <DynamicPage />} />
    </Routes>
  );
}
